<template>
    <el-main>
        <div style="margin-bottom: 20px;">
            <span class="bcbc" :class="sstj.sj == 'THIS_MONTH' ? 'bcbcb' : 'bcbca'" @click="kjsearch('THIS_MONTH')">本月</span>
            <span class="bcbc" :class="sstj.sj == 'LAST_MONTH' ? 'bcbcb' : 'bcbca'" @click="kjsearch('LAST_MONTH')">上月</span>
            <span class="bcbc" :class="sstj.sj == 'THIS_YEAR' ? 'bcbcb' : 'bcbca'" @click="kjsearch('THIS_YEAR')">本年</span>
            <span class="bcbc" :class="sstj.sj == 'LAST_YEAR' ? 'bcbcb' : 'bcbca'" @click="kjsearch('LAST_YEAR')">上年</span>
            <el-date-picker
                size="small"
                style="margin-right: 20px;width: 30rem;"
                v-model="sstj.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="getData"
            >
            </el-date-picker>
            <el-button type="primary" size="small" style="background-color: #a8a8a8;border: solid 0rem #f4f4f4;" @click="resetGetData">重置</el-button>
            <el-button type="primary" icon="el-icon-search" size="small" class="queryButton queryButtonPadding" @click="getData">搜索</el-button>
        </div>
        <div style="width: 100%;">
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="cece">
                        <img src="../../assets/images/xc/xcgk.png" style="vertical-align: middle;margin-right: 4px;">
                        巡查概况
                    </div>
                    <div style="width: 100%;height: 270px;background-color: #fff;">
                        <div id="xcgkChartPie" class="btys"></div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="cece">
                        <img src="../../assets/images/xc/yqtj.png" style="vertical-align: middle;margin-right: 4px;">
                        逾期统计
                    </div>
                    <div style="width: 100%;height: 270px;background-color: #fff;">
                        <div id="yqtjChartPie" class="btys"></div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="cece">
                        <img src="../../assets/images/xc/yhtj.png" style="vertical-align: middle;margin-right: 4px;">
                        隐患统计
                    </div>
                    <div style="width: 100%;height: 270px;background-color: #fff;">
                        <div id="yhtjChartPie" class="btys"></div>
                    </div>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px;">
                <div>
                    <div class="cece">
                        <img src="../../assets/images/xc/xccs.png" style="vertical-align: middle;margin-right: 4px;">
                        巡查次数
                    </div>
                    <div style="width: 100%;height: 320px;background-color: #fff;">
                        <div id="xccsChartPie" class="btys"></div>
                    </div>
                </div>
            </el-row>
        </div>
    </el-main>
</template>
  
<script>
export default {
    data() {
        return {
            sstj:{
                sj:'THIS_MONTH',
                date:[],
            },
            fxData:{},
            xcgkData:{},
            csDataX:[],
            csDataY:[],
        }
    },
    mounted() {
        this.getData();
        this.getDataA();
    },
    watch: {
        "$store.state.head.skCd"() {
            this.getData();
            this.getDataA();
        }
    },
    methods: {
        getData() {
            const data = {
                queryDateType:this.sstj.sj,
                dtGT:this.sstj.date[0],
                dtLE:this.sstj.date[1],
            };
            this.request.get("/rm-xxcrw/v1/queryXcTjfx",{ params: data }).then((res) => {
                if (res.ok) {
                    this.fxData = res.data;
                    if (this.fxData.xccs) {
                        this.fxData.xccs.forEach(element => {
                            this.csDataX.push(element.sjstr);
                            this.csDataY.push(element.cs);
                        });
                    }
                    this.$nextTick(()=>{
                        this.initYqtjChar();
                        this.initYhtjChar();
                        this.initXccsChar();
                    });
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        getDataA(){
            const data = {
                queryDateType:this.sstj.sj,
                dtGT:this.sstj.date[0],
                dtLE:this.sstj.date[1],
            };
            this.request.get("/rm-xxcrw/v1/xcgk",{ params: data }).then((res) => {
                if (res.ok) {
                    this.xcgkData = res.data;
                    this.$nextTick(()=>{
                        this.initXcgkChar();
                    });
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        kjsearch(a){
            this.sstj.sj = a;
            this.getData();
        },
        resetGetData(){
            this.sstj = {
                sj:'THIS_MONTH',
                date:[],
            }
            this.getData();
        },
        initXcgkChar() {
            let roseCharts = this.$echarts.init(document.getElementById("xcgkChartPie"));
            roseCharts.setOption(
                {
                tooltip: {
                    trigger: 'item',
                    formatter: (params) => {
                        const str = `${params.data.name}`
                        return str
                    },
                },
                legend: {
                    itemWidth: 7,   // 设置图例图形的宽
                    itemHeight: 7,  // 设置图例图形的高
                    left: 'left',   //图例靠左
                    bottom: '1%',
                    orient: 'horizontal',  //垂直排列
                    data:[
                        {
                            name: '逾期未巡：'+this.xcgkData.wxc+'个',
                            icon: 'circle', 
                            textStyle: {fontSize: '16px'}
                        },
                        {
                            name: '待巡查：'+this.xcgkData.xcz+'个',
                            icon: 'circle', 
                            textStyle: {fontSize: '16px'}
                        },
                        {
                            name: '已巡查：'+this.xcgkData.yxc+'个',
                            icon: 'circle', 
                            textStyle: {fontSize: '16px'}
                        },
                    ]
                },
                color: ['#ee7f41', '#f5c042', '#5979f5'],
                series: [
                    {
                    type: 'pie',
                    radius: ['30%', '50%'],
                    center: ['50%', '42%'], //图的位置，距离左跟上的位置
                    label: {
                        formatter: (d) => {
                            return d.name.replace(d.name.substring(d.name.indexOf('：'), d.name.length),':\n' +  d.percent  + '%')
                        }
                        // position: 'inside', //扇形外侧outside 扇形上inside 中心位置center
                    },
                    labelLine: {
                        show: true,
                        length: 10,
                        length2: 10,//第二条线的长度
                        smooth: false,
                        lineStyle: {
                            width: 1,
                            type: 'solid'
                        }
                    },
                    data: [
                        { value: this.xcgkData.wxc, name: '待巡查：'+this.xcgkData.wxc+'个'},
                        { value: this.xcgkData.xcz, name: '巡查中：'+this.xcgkData.xcz+'个'},
                        { value: this.xcgkData.yxc, name: '已巡查：'+this.xcgkData.yxc+'个'},
                    ]
                    }
                ]
                },
                true
            );
            window.onresize = function () {
                roseCharts.resize();
            };
        },
        initYqtjChar() {
            let roseCharts = this.$echarts.init(document.getElementById("yqtjChartPie"));
            roseCharts.setOption(
                {
                tooltip: {
                    trigger: 'item',
                    formatter: (params) => {
                        const str = `${params.data.name}`
                        return str
                    },
                },
                legend: {
                    itemWidth: 7,   // 设置图例图形的宽
                    itemHeight: 7,  // 设置图例图形的高
                    left: 'left',   //图例靠左
                    bottom: '1%',
                    orient: 'horizontal',  //垂直排列
                    data:[
                        {
                            name: '逾期未巡：'+this.fxData.yqtj.yqsl+'个',
                            icon: 'circle', 
                            textStyle: {fontSize: '16px'}
                        },
                        {
                            name: '待巡查：'+this.fxData.yqtj.dxcsl+'个',
                            icon: 'circle', 
                            textStyle: {fontSize: '16px'}
                        },
                        {
                            name: '已巡查：'+this.fxData.yqtj.yxcsl+'个',
                            icon: 'circle', 
                            textStyle: {fontSize: '16px'}
                        },
                    ]
                },
                color: ['#ee7f41', '#f5c042', '#5979f5'],
                series: [
                    {
                    type: 'pie',
                    radius: ['30%', '50%'],
                    center: ['50%', '42%'], //图的位置，距离左跟上的位置
                    label: {
                        formatter: (d) => {
                            return d.name.replace(d.name.substring(d.name.indexOf('：'), d.name.length),':\n' +  d.percent  + '%')
                        }
                        // position: 'inside', //扇形外侧outside 扇形上inside 中心位置center
                    },
                    labelLine: {
                        show: true,
                        length: 10,
                        length2: 10,//第二条线的长度
                        smooth: false,
                        lineStyle: {
                            width: 1,
                            type: 'solid'
                        }
                    },
                    data: [
                        { value: this.fxData.yqtj.yqsl, name: '逾期未巡：'+this.fxData.yqtj.yqsl+'个'},
                        { value: this.fxData.yqtj.dxcsl, name: '待巡查：'+this.fxData.yqtj.dxcsl+'个'},
                        { value: this.fxData.yqtj.yxcsl, name: '已巡查：'+this.fxData.yqtj.yxcsl+'个'},
                    ]
                    }
                ]
                },
                true
            );
            window.onresize = function () {
                roseCharts.resize();
            };
        },
        initYhtjChar() {
            let roseCharts = this.$echarts.init(document.getElementById("yhtjChartPie"));
            roseCharts.setOption(
                {
                tooltip: {
                    trigger: 'item',
                    formatter: (params) => {
                        const str = `${params.data.name}`
                        return str
                    },
                },
                legend: {
                    itemWidth: 7,   // 设置图例图形的宽
                    itemHeight: 7,  // 设置图例图形的高
                    left: 'left',   //图例靠左
                    bottom: '1%',
                    orient: 'horizontal',  //垂直排列
                    data:[
                        {
                            name: '未处理隐患：'+this.fxData.yhtj.wclyhsl+'个',
                            icon: 'circle', 
                            textStyle: {fontSize: '16px'}
                        },
                        {
                            name: '已处理：'+this.fxData.yhtj.yclsl+'个',
                            icon: 'circle', 
                            textStyle: {fontSize: '16px'}
                        },
                    ]
                },
                color: ['#ee7f41', '#f5c042'],
                series: [
                    {
                    type: 'pie',
                    radius: ['30%', '50%'],
                    center: ['50%', '42%'], //图的位置，距离左跟上的位置
                    label: {
                        formatter: (d) => {
                            return d.name.replace(d.name.substring(d.name.indexOf('：'), d.name.length),':\n' +  d.percent  + '%')
                        }
                        // position: 'inside', //扇形外侧outside 扇形上inside 中心位置center
                    },
                    labelLine: {
                        show: true,
                        length: 10,
                        length2: 10,//第二条线的长度
                        smooth: false,
                        lineStyle: {
                            width: 1,
                            type: 'solid'
                        }
                    },
                    data: [
                        { value: this.fxData.yhtj.wclyhsl, name: '未处理隐患：'+this.fxData.yhtj.wclyhsl+'个'},
                        { value: this.fxData.yhtj.yclsl, name: '已处理：'+this.fxData.yhtj.yclsl+'个'},
                    ]
                    }
                ]
                },
                true
            );
            window.onresize = function () {
                roseCharts.resize();
            };
        },
        initXccsChar() {
            let roseCharts = this.$echarts.init(document.getElementById("xccsChartPie"));
            roseCharts.setOption(
                {
                color: ['#4aa4fa'],
                tooltip: {
                    //鼠标悬停提示内容
                    trigger: 'axis',
                    confine: true,
                    axisPointer: {
                        type: 'cross',
                    },
                },
                xAxis: {
                    type: 'category',
                    name: '日期',
                    boundaryGap: false,//x轴两边不留空白
                    data: this.csDataX,
                    axisTick: {
                        show: false  // 是否显示刻度线
                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '次数',
                        scale:true,
                    },
                ],
                series: [
                    {
                        name: '次数',
                        data: this.csDataY,
                        type: 'line',
                        smooth: true,
                        areaStyle: {
                            color: {
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0.1,
                                        color: 'rgba(175, 214, 251, 0.7) ' // 0% 处的颜色
                                    },
                                    {
                                        offset: 0.9,
                                        color: 'rgba(175, 214, 251, 0.1)' // 100% 处的颜色
                                    }
                                ]
                            }
                        }
                    }
                ]
                },
                true
            );
            window.onresize = function () {
                roseCharts.resize();
            };
        },
    },
}
</script>
<style scoped>
.bcbc{
    cursor: pointer;
    padding: 6px 20px;
    border-radius: 5px;font-size: 16px;
    margin-right: 20px;
}
.bcbca{
    background-color: #fff;
    color: #000;
}
.bcbcb{
    background-color: #6aa9f6;
    color: #fff;
}
.cece{
    color: #000;
    font-size: 16px;
    background-color: #fbfbfb;
    padding: 15px 10px;
    vertical-align: middle;
}

.btys {
    height: 100%;
    width: 100%;
}
</style>